<div class="hasTabs">
  <nav class="cat__core__top-sidebar cat__core__top-sidebar--bg cat__core__top-sidebar--tabs">

  <span class="cat__core__title d-block mt-2 mb-0 mb-lg-2">
    <strong *ngIf="!isTeam">{{participantLabel}} RESOURCES</strong>
    <strong *ngIf="isTeam">CAPTAIN GUIDE</strong>
  </span>

  </nav>
  <div class="nav-tabs-horizontal tab-body">
    <ul ngbNav #tabSet="ngbNav" ngbNav class="nav-link-inside nav-tabs" [activeId]="activeTab">
      <li ngbNavItem="startTab">
        <a ngbNavLink>
          <a *ngIf="!isTeam" [routerLink]="['/fundraisingToolbox', eventService.selectedEvent.value, 'individual']" [queryParams]="{ activeTab: 'startTab' }">Getting started</a>
          <a *ngIf="isTeam" [routerLink]="['/fundraisingToolbox', eventService.selectedEvent.value, 'team']" [queryParams]="{ activeTab: 'startTab' }">Getting started</a>
        </a>
        <ng-template ngbNavContent>
          <app-five-steps [fundraisingTips]="tips" [gettingStartedContent]="firstSteps?.content"></app-five-steps>
        </ng-template>
      </li>
      <li ngbNavItem="firstHoursTab" *ngIf="firstHours">
        <a ngbNavLink>
          <a *ngIf="!isTeam" [routerLink]="['/fundraisingToolbox', eventService.selectedEvent.value, 'individual']" [queryParams]="{ activeTab: 'firstHoursTab' }" class = "d-block d-lg-none">First Hours</a>
          <a *ngIf="!isTeam" [routerLink]="['/fundraisingToolbox', eventService.selectedEvent.value, 'individual']" [queryParams]="{ activeTab: 'firstHoursTab' }" class = "d-none d-lg-block">The First 48 Hours</a>
          <a *ngIf="isTeam" [routerLink]="['/fundraisingToolbox', eventService.selectedEvent.value, 'team']" [queryParams]="{ activeTab: 'firstHoursTab' }" class = "d-block d-lg-none">First Hours</a>
          <a *ngIf="isTeam" [routerLink]="['/fundraisingToolbox', eventService.selectedEvent.value, 'team']" [queryParams]="{ activeTab: 'firstHoursTab' }" class = "d-none d-lg-block">The First 48 Hours</a>
        </a>
        <ng-template ngbNavContent>
          <app-first-hours [data]="firstHours"></app-first-hours>
        </ng-template>
      </li>
      <li ngbNavItem="downloadsTab" *ngIf="downloads">
        <a ngbNavLink>
          <a *ngIf="!isTeam" [routerLink]="['/fundraisingToolbox', eventService.selectedEvent.value, 'individual']" [queryParams]="{ activeTab: 'downloadsTab' }">Downloads</a>
          <a *ngIf="isTeam" [routerLink]="['/fundraisingToolbox', eventService.selectedEvent.value, 'team']" [queryParams]="{ activeTab: 'downloadsTab' }">Downloads</a>
        </a>
        <ng-template ngbNavContent>
          <app-downloads [downloads]="downloads"></app-downloads>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="tabSet" class="mt-2"></div>

  </div>

</div>
